import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import { injectIntl, FormattedMessage } from 'react-intl'



const HeroVideo = () => {
  const { thumb } = useStaticQuery(graphql`{
    thumb: file(relativePath: { eq: "photogallery/_KLA2065.jpg"}) {
      childImageSharp {
        fluid(maxWidth: 768) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }`);
  return (
    <div className="hero-video">
      <div className="hero-video__iframe-wrapper">
        <iframe className="hero-video__iframe" width="100%" height="100%" title="Hero"
          src="https://www.youtube.com/embed/DX5t3pZsII4?controls=0&showinfo=0&rel=0&autoplay=1&mute=1&loop=1&playlist=DX5t3pZsII4"
          frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen>
        </iframe>
        <Img fluid={thumb.childImageSharp.fluid} className="hero-video__fallback"/>
      </div>
      <div className="row">
        <div className="col-12 text-center">
          <div className="hero-video__content">
            <h3>
              <FormattedMessage id="home-hero-title" />
            </h3>
            <div className="hero-video__recap">
              <div className="row">
                <div className="col-12 col-sm-4">
                  <div className="item">
                    <span className="count">63</span>
                    <FormattedMessage id="aziende" />
                  </div>
                </div>
                <div className="col-12 col-sm-4">
                  <div className="item">
                    <span className="count">130</span>
                    <FormattedMessage id="partecipanti" />
                  </div>
                </div>
                <div className="col-12 col-sm-4">
                  <div className="item">
                    <span className="count">16</span>
                    <FormattedMessage id="hero-speaker" />
                  </div>
                </div>
              </div>
            </div>
            <h1>
              <FormattedMessage id="hero-grazie" />
            </h1>
            <h2>
              <FormattedMessage id="ci-rivediamo-2020" />
            </h2>
            <a href="https://www.linkedin.com/groups/12076840/" title="Community Linkedin" className="btn-cta btn-style-2">
              <FormattedMessage id="linkedin-community" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );

}

export default injectIntl(HeroVideo);